import Vue from 'vue'
import Vuex from 'vuex'
import VuexPersistence from 'vuex-persist'

import api from '@/api'

import cacheIndirizziModule from './modules/cache-indirizzi'
import globalModule from './modules/global'
import sessionModule from './modules/session'
import settingsModule from './modules/settings'

Vue.use(Vuex)

/**
 * IMPORTANTE: USO NEI COMPONENTI
 * Per usare lo state nei componenti è necessario usare mapState nelle computed property.
 * Ciò evita di dover definire dei getters per ogni valore nello state.
 */

const vuexLocalStorage = new VuexPersistence({
    key: 'settings',
    storage: window.localStorage,
    reducer: state => {
        const { loading, ...stateWithoutLoading } = state.cacheIndirizzi // Rimozione valori "loading" da stato per evitare slavataggio valori a "true"
        return { cacheIndirizzi: stateWithoutLoading, settings: state.settings }
    },
    modules: ['settings', 'cacheIndirizzi']
})

const vuexSessionStorage = new VuexPersistence({
    key: 'auth',
    storage: window.sessionStorage,
    restoreState: (key, storage) => {
        //  Necessario per impostare il token nell'header
        if (storage.auth) {
            let state = JSON.parse(storage.auth)
            if (state.session.token) api.instance.setTokenHeader(state.session.token)
            return state
        }
    },
    modules: ['session']
})

/**
 * In-memory (no storage): { global },
 * Local storage: { settings, cache-indirizzi }
 * Session storage: { session }
 */
export default new Vuex.Store({
    modules: {
        cacheIndirizzi: cacheIndirizziModule,
        global: globalModule,
        session: sessionModule,
        settings: settingsModule
    },
    plugins: [vuexLocalStorage.plugin, vuexSessionStorage.plugin]
})
